import { Languages } from '@frontend/common';
import { getCorrectTranslation, useLocale } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';

import { TranslationProps } from './translations-container.component';

export interface ViewProps {
    currentAccount: string;
    data: { [key: string]: string | null }[] | null;
}

const useTranslationContainer = (props: TranslationProps): ViewProps => {
    const { currentAccount } = useAccountRepository();
    const { availableLanguages } = useLocale();
    const actualAvailableLanguages = availableLanguages ?? Languages;

    const generateTranslationData = (obj: any, fieldPrefix: string) => {
        const translationData: { [key: string]: string | null } = {};

        for (const language of actualAvailableLanguages) {
            translationData[language.displayName] = getCorrectTranslation(language.value, obj, fieldPrefix);
        }

        return translationData;
    };

    const constructTranslationList = (): { [key: string]: string | null }[] => {
        return props.translations.map((item) => generateTranslationData(props.object, item.toLowerCase()));
    };

    const data = constructTranslationList();

    return {
        currentAccount,
        data
    };
};

export default useTranslationContainer;
